/**
 * Paletas y degradados predefinidos. Son constantes del código: en el navegador solo se guarda
 * el `id`, nunca estos valores.
 */

export interface Paleta {
  id: string;
  nombre: string;
  fondo: string;
  /** Color de tarjetas, columnas, encabezado y paneles. */
  superficie: string;
  acento: string;
}

export interface Degradado {
  id: string;
  nombre: string;
  desde: string;
  hasta: string;
}

export const PALETAS: readonly Paleta[] = [
  { id: 'marfil', nombre: 'Marfil', fondo: '#f4efe6', superficie: '#fffdf8', acento: '#8a4b14' },
  { id: 'cielo', nombre: 'Cielo', fondo: '#e8f1fb', superficie: '#ffffff', acento: '#1f5fa8' },
  { id: 'menta', nombre: 'Menta', fondo: '#e6f4ec', superficie: '#ffffff', acento: '#1b7a4a' },
  { id: 'lavanda', nombre: 'Lavanda', fondo: '#efeafa', superficie: '#ffffff', acento: '#5b3fa8' },
  { id: 'durazno', nombre: 'Durazno', fondo: '#fdeee6', superficie: '#fffaf6', acento: '#b4441c' },
  { id: 'grafito', nombre: 'Grafito', fondo: '#1e1f24', superficie: '#2a2c33', acento: '#8ab4ff' },
  {
    id: 'medianoche',
    nombre: 'Medianoche',
    fondo: '#0c1424',
    superficie: '#152036',
    acento: '#5fd0c8',
  },
  { id: 'bosque', nombre: 'Bosque', fondo: '#12231b', superficie: '#1b332a', acento: '#9ad66f' },
];

export const DEGRADADOS: readonly Degradado[] = [
  { id: 'amanecer', nombre: 'Amanecer', desde: '#fde4d0', hasta: '#e3d4f7' },
  { id: 'oceano', nombre: 'Océano', desde: '#cfe8f7', hasta: '#d5f0e4' },
  { id: 'aurora', nombre: 'Aurora', desde: '#d3f0e2', hasta: '#cfd9f6' },
  { id: 'atardecer', nombre: 'Atardecer', desde: '#f9d5c7', hasta: '#c9c3ee' },
  { id: 'noche', nombre: 'Noche', desde: '#0f172a', hasta: '#1e3a5f' },
  { id: 'selva', nombre: 'Selva', desde: '#12261d', hasta: '#27493a' },
];
